import React from "react";

import "./ProfileIcon.scss";

export type ProfileIconProps = {
  cx?: string;
  username: string;
};

//TODO : color & bgColor & width+height+font size!!

export const ProfileIcon: React.FC<ProfileIconProps> = ({
  cx = "",
  username,
}) => {
  return (
    <div className={`ProfileIcon ${cx}`}>
      <span>{username.charAt(0).toUpperCase()}</span>
    </div>
  );
};
